// extracted by mini-css-extract-plugin
module.exports = {"emptyWrap":"Empty_emptyWrap__iJ9Z3","text":"Empty_text__3YTos","btnBox":"Empty_btnBox__3wkk4"};